/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import AutocompleteComponent from '../../common/component/AutocompleteComponent';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import { FilterStyles } from '../table/tableCss';
import TypeSelector from '../../common/component/typeSelector';
import {
  typeOptionsDoTp,
  typeOptionsMilieuSensibility,
  typeOptionsMilieuDilution,
} from '../options/optionsHelper';

const DoubleFilter = (props: any) => {
  const [module] = useState<string>(props.module);
  // filter one
  const [titleOne] = useState<string>(props.titleOne);
  const [filtreNameOne] = useState<string>(
    props.filterNameOne
  );
  const [optionsFilterOne, setOptionsFiltreOne] = useState<any>(
    props.filterOneOptions || []
  );
  const [filterOneParam, setFilterOneParam] = useState<any>(
    null
  );
  // filter two
  const [titleTwo] = useState<string>(props.titleTwo);
  const [filtreNameTwo] = useState<string>(
    props.filterNameTwo
  );
  const [optionsFilterTwo, setOptionsFiltreTwo] = useState<any>(
    props.filterTwoOptions || []
  );
  const [filterTwoParam, setFilterTwoParam] = useState<any>(null);

  // event to trigger update content of table
  useEffect(() => {
    if (filterOneParam !== null) return props.parentCallbackOne(filterOneParam);
  }, [filterOneParam]);

  useEffect(() => {
    if (filterTwoParam !== null) return props.parentCallbackTwo(filterTwoParam);
  }, [filterTwoParam]);

  // get new values of options
  useEffect(() => {
    setOptionsFiltreOne(props.filterOneOptions);
  }, [props.filterOneOptions]);

  useEffect(() => {
    setOptionsFiltreTwo(props.filterTwoOptions);
  }, [props.filterTwoOptions]);

  // onChange of dropdownlist
  const onFilterChange = (pOption: any, setter: any, pFilterName: string) => {
    if (pOption === null) {
      const objectToSend = { name: '', code: '', paths: '' };
      setter(objectToSend);
      window.sessionStorage.setItem(
        module + '_' + pFilterName,
        JSON.stringify(objectToSend)
      );
    } else {
      const objectToSend = {
        name: pOption.name,
        code: pOption.code,
        paths: pOption.paths || '',
      };
      setter(objectToSend);
      window.sessionStorage.setItem(
        module + '_' + pFilterName,
        JSON.stringify(objectToSend)
      );
    }
  };

  const onFilterOneChange = (event: any, option: any) => {
    onFilterChange(option, setFilterOneParam, filtreNameOne);
  };

  const onFilterTwoChange = (event: any, option: any) => {
    onFilterChange(option, setFilterTwoParam, filtreNameTwo);
  };

  // define options for radio boxes
  const defineRadioParams = (pModule: string, pOption: string) => {
    if (pModule === 'do') {
      return typeOptionsDoTp;
    } else {
      if (pOption === 'sensibility') {
        return typeOptionsMilieuSensibility;
      } else {
        return typeOptionsMilieuDilution;
      }
    }
  };

  return (
    <Container className='filterForm'>
      <Styles />
      <Container className='rowContainer'>
        <Container
          style={{
            display: 'inline-block',
            width: '-webkit-fill-available',
          }}
        >
          <Word
            value={titleOne}
            textStyle='normalReg'
            variant='p'
            automatedTestId={'id-' + filtreNameOne}
          />
          <AutocompleteComponent
            id={module + '-filtre-' + filtreNameOne}
            Listoption={optionsFilterOne}
            onChangeValue={onFilterOneChange}
            defaultValue={JSON.parse(
              window.sessionStorage.getItem(module + '_' + filtreNameOne)!
            )}
          />
        </Container>
        {module !== 'do' && module !== 'milieu' ? (
          <Container
            style={{
              display: 'inline-block',
              paddingLeft: '5px',
              width: '-webkit-fill-available',
            }}
          >
            <Word
              value={titleTwo}
              textStyle='normalReg'
              variant='p'
              automatedTestId={'id-' + filtreNameTwo}
            />
            <AutocompleteComponent
              id={module + '-filtre-' + filtreNameTwo}
              Listoption={optionsFilterTwo}
              onChangeValue={onFilterTwoChange}
              defaultValue={JSON.parse(
                window.sessionStorage.getItem(module + '_' + filtreNameTwo)!
              )}
            />
          </Container>
        ) : (
          <Container
            className='colContainer'
            id='Container-id-type'
            style={{
              display: 'inline-block',
              paddingLeft: '5px',
              width: '-webkit-fill-available',
            }}
          >
            <Word
              value='Type'
              textStyle='normalReg'
              variant='p'
              automatedTestId='id-type'
            />
            <TypeSelector
              sendSelectedColor={onFilterTwoChange}
              radioParams={defineRadioParams(props.module, props.option)}
              module={props.module}
              option={props.option}
            />
          </Container>
        )}
      </Container>
    </Container>
  );
};
const Styles = FilterStyles;
export default DoubleFilter;
